import { resolveAssetUrl } from "../../../utils/resolveAssetUrl";
import { useForm } from "../context";

const BannerBottom = () => {
  const { checkout, firstItem } = useForm();

  const bottomBanner = checkout.styleConfig?.bottomBanner;

  // Verifica se está vazio, é array vazio, ou não é string
  if (!bottomBanner || Array.isArray(bottomBanner) || typeof bottomBanner !== 'string') {
    return null;
  }

  return (
    <img loading='lazy' src={resolveAssetUrl(bottomBanner)} alt={firstItem?.description} className='hidden sm:block object-cover w-full rounded-lg' />
  );
};

export default BannerBottom;
